import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Icon from '../components/common/Icon';
import Breadcrumbs from '../components/common/Breadcrumbs';
import SectionHeader from '../components/common/SectionHeader';
import NewsCard from '../components/common/NewsCard';
import EventCard from '../components/common/EventCard';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import FilterSelect from '../components/common/FilterSelect';

const deptData = {
  organizzazione: {
    title: 'Organizzazione',
    heroImage: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=1600&auto=format&fit=crop',
    head: { 
      name: 'Marco Rossi', 
      role: 'Responsabile Nazionale Organizzazione', 
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&auto=format&fit=crop',
      bio: "Attivista dalla nascita, Marco ha coordinato centinaia di iniziative sul territorio. Crede che la partecipazione sia l'unico modo per cambiare le cose. Laureato in Scienze Politiche, coordina la segreteria nazionale dal 2022."
    },
    description: "Il cuore pulsante della nostra comunità. Coordiniamo la rete dei circoli e delle federazioni, gestendo la partecipazione democratica in tutta Italia.",
    color: 'var(--color-primary)',
    icon: 'Settings',
    tasks: [
      { title: 'Tesseramento', text: 'Gestione anagrafe e nuovi iscritti.', icon: 'UserPlus' },
      { title: 'Territorio', text: 'Coordinamento della rete dei circoli.', icon: 'Map' },
      { title: 'Eventi', text: 'Logistica grandi appuntamenti nazionali.', icon: 'Calendar' },
      { title: 'Supporto', text: 'Assistenza diretta ai territori.', icon: 'HelpCircle' }
    ],
    news: [
      { id: 1, title: 'Nuovo regolamento tesseramento 2026', date: '12 Apr 2026', category: 'Organizzazione', excerpt: 'Tutte le novità sulle modalità di iscrizione e rinnovo per l\'anno in corso.', image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=600' },
      { id: 2, title: 'Incontro nazionale dei responsabili organizzativi', date: '05 Apr 2026', category: 'Eventi', excerpt: 'Un momento di confronto cruciale per definire le strategie territoriali.', image: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=600' },
      { id: 3, title: 'GD in tour: il viaggio tra i circoli', date: '28 Mar 2026', category: 'Territorio', excerpt: 'Racconto delle prime tappe del tour nazionale della segreteria.', image: 'https://images.unsplash.com/photo-1529156069898-49953eb1b5ae?q=80&w=600' }
    ],
    events: [
      { id: 101, title: 'Corso di formazione per Segretari', day: '20', month: 'Mag', location: 'Roma, Centro Congressi', time: '10:00 – 17:00', badge: 'Formazione', image: 'https://images.unsplash.com/photo-1524178232363-1fb28f74b55a?q=80&w=600' }
    ],
    documents: [
      { title: 'Vademecum Circoli 2026', type: 'Guida Operativa', date: '10 Gen 2026', badge: 'PDF', size: '2.4 MB' },
      { title: 'Modulo Tesseramento 2026', type: 'Modulistica', date: '15 Gen 2026', badge: 'DOCX', size: '1.1 MB' }
    ]
  },
  lavoro: {
    title: 'Lavoro',
    heroImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1600&auto=format&fit=crop',
    head: { 
      name: 'Elena Neri', 
      role: 'Responsabile Nazionale Lavoro', 
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=400&auto=format&fit=crop',
      bio: "Elena è un'esperta di politiche del lavoro e welfare. Ha lavorato per anni in ambito sindacale prima di dedicarsi a tempo pieno alla politica. Il suo obiettivo è un lavoro dignitoso e sicuro per ogni giovane."
    },
    description: "Combattiamo per i diritti di una generazione precaria. Elaboriamo proposte per il salario minimo, la sicurezza e la dignità nel mondo del lavoro.",
    color: '#10b981',
    icon: 'Briefcase',
    tasks: [
      { title: 'Salario Minimo', text: 'Campagna nazionale per i 9€ l\'ora.', icon: 'DollarSign' },
      { title: 'Precarietà', text: 'Osservatorio sulle nuove forme di sfruttamento.', icon: 'Eye' },
      { title: 'Sindacati', text: 'Relazioni stabili con le parti sociali.', icon: 'Link' },
      { title: 'Formazione', text: 'Seminari sui diritti dei lavoratori.', icon: 'BookOpen' }
    ],
    news: [
      { id: 4, title: 'Mobilitazione per il Salario Minimo', date: '20 Apr 2026', category: 'Lavoro', excerpt: 'Migliaia di firme raccolte nelle prime 48 ore della mobilitazione.', image: 'https://images.unsplash.com/photo-1540317580384-e5d43616b9aa?q=80&w=600' },
      { id: 5, title: 'Rapporto Stage: basta sfruttamento', date: '10 Apr 2026', category: 'Istruzione', excerpt: 'I dati allarmanti sull\'utilizzo dei tirocini extracurriculari.', image: 'https://images.unsplash.com/photo-1521791136064-7986c2959d43?q=80&w=600' },
      { id: 6, title: 'Sicurezza sul Lavoro: serve una svolta', date: '01 Apr 2026', category: 'Diritti', excerpt: 'Le nostre proposte per fermare le stragi silenziose nei cantieri.', image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?q=80&w=600' }
    ],
    events: [
      { id: 102, title: 'Webinar: I nuovi contratti precari', day: '15', month: 'Mag', location: 'Online, Zoom Platform', time: '18:30 – 20:00', badge: 'Formazione', image: 'https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=600' }
    ],
    documents: [
      { title: 'Proposta di Legge Salario Minimo', type: 'Dossier', date: '20 Feb 2026', badge: 'PDF', size: '1.5 MB' },
      { title: 'Report Precarietà Giovanile 2025', type: 'Report', date: '15 Gen 2026', badge: 'PDF', size: '4.2 MB' }
    ]
  }
};

const DipartimentoPage = () => {
  const { id } = useParams();
  const data = deptData[id] || deptData.organizzazione;

  const breadcrumbs = [
    { label: 'Home', path: '/' },
    { label: 'Dipartimenti', path: '/dipartimenti' },
    { label: data.title }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <Layout>
      {/* EPIC HERO SECTION */}
      <section className="hero--epic">
        <div className="hero__bg">
          <div className="hero__image" style={{ backgroundImage: `url(${data.heroImage})` }}></div>
          <div className="hero__overlay" style={{ background: `linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(9,9,11,0.95) 100%)` }}></div>
        </div>
        
        <div className="hero__content-epic container" style={{ color: '#fff' }}>
          <div className="reveal" style={{ marginBottom: 'var(--space-8)' }}>
            <Breadcrumbs items={breadcrumbs} style={{ color: 'rgba(255,255,255,0.7)' }} />
          </div>
          
          <div className="reveal mb-6">
            <span className="badge" style={{ background: data.color, color: '#fff', border: 'none', padding: 'var(--space-2) var(--space-4)', fontSize: 'var(--text-xs)' }}>
              Dipartimento Nazionale
            </span>
          </div>
          
          <h1 className="hero__title-epic text-reveal-trigger" style={{ color: '#fff', fontSize: 'clamp(3rem, 8vw, 6rem)' }}>
            <span className="line text-reveal"><span className="word text-reveal__inner">{data.title}</span></span>
          </h1>
          
          <p className="hero__subtitle-epic reveal" style={{ color: 'rgba(255,255,255,0.9)', maxWidth: '700px', fontSize: 'var(--text-body-lg)' }}>
            {data.description}
          </p>
        </div>
      </section>

      {/* RESPONSIBLE & TASKS SECTION */}
      <section className="section" style={{ marginTop: '-120px', position: 'relative', zIndex: 10, paddingTop: 0 }}>
        <div className="container">
          <div className="reveal reveal--scale mb-12">
            <div style={{ 
              background: 'rgba(255, 255, 255, 0.8)', 
              backdropFilter: 'blur(20px)',
              padding: 'var(--space-8)', 
              borderRadius: 'var(--radius-3xl)',
              boxShadow: '0 30px 60px rgba(0,0,0,0.12)',
              border: '1px solid rgba(255,255,255,0.3)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 'var(--space-10)'
            }}>
              <div style={{ width: '180px', height: '180px', borderRadius: 'var(--radius-2xl)', overflow: 'hidden', boxShadow: 'var(--shadow-lg)' }}>
                <img src={data.head.image} alt={data.head.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ flex: 1, minWidth: '300px' }}>
                <span className="text-overline mb-2 block" style={{ color: data.color }}>Responsabile Nazionale</span>
                <h2 className="h2 mb-4">{data.head.name}</h2>
                <p className="text-body text-secondary mb-6 italic" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  "{data.head.bio}"
                </p>
                <div className="flex gap-4">
                  <Link to="#" className="btn btn--primary">Contatta {data.head.name.split(' ')[0]}</Link>
                  <div className="flex gap-3 ml-4 items-center">
                    <Link to="#" className="text-secondary hover:text-primary transition-colors"><Icon name="Twitter" size={20} /></Link>
                    <Link to="#" className="text-secondary hover:text-primary transition-colors"><Icon name="Linkedin" size={20} /></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* MISSION & TASKS INTEGRATED */}
          <div style={{ background: 'var(--color-bg-subtle)', padding: 'var(--space-10)', borderRadius: 'var(--radius-3xl)', border: '1px solid var(--color-border-subtle)' }} className="reveal reveal--scale">
            <SectionHeader overline="Obiettivi" title="Cosa facciamo" className="mb-10" />
            <div className="grid grid-4 gap-6">
              {data.tasks.map((task, i) => (
                <div key={i} className="flex flex-col gap-4 p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow reveal stagger-2">
                  <div style={{ color: data.color, background: `${data.color}15`, width: '48px', height: '48px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon name={task.icon} size={24} />
                  </div>
                  <div>
                    <h4 className="h5 mb-2">{task.title}</h4>
                    <p className="text-xs text-secondary">{task.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEWS SECTION - MATCHING NOTIZIE PAGE STYLE */}
      <section className="section bg-subtle">
        <div className="container">
          <SectionHeader overline="Hub Editoriale" title="Ultime dal Dipartimento" className="mb-8" />
          
          <Toolbar
            className="mb-10 reveal"
            left={<SearchBar placeholder="Cerca tra i contenuti..." ariaLabel="Cerca notizie dipartimento" />}
            right={<>
              <FilterSelect label="Categoria" options={['Tutte', 'Attualità', 'Politica', 'Territorio']} />
              <FilterSelect label="Data" options={['Ultimo mese', 'Ultimi 6 mesi', 'Tutti']} />
            </>}
          />

          <div className="grid grid-3 gap-8">
            {data.news.map((n, i) => (
              <NewsCard 
                key={n.id} 
                news={n} 
                title={n.title}
                excerpt={n.excerpt}
                badge={n.category}
                meta={[n.date]}
                image={n.image}
                className={`reveal stagger-${i + 1}`} 
              />
            ))}
          </div>
        </div>
      </section>

      {/* EVENTS SECTION - MATCHING EVENTI PAGE STYLE */}
      <section className="section bg-white border-bottom">
        <div className="container">
          <SectionHeader overline="Appuntamenti" title="Agenda e Formazione" className="mb-8" />
          
          <Toolbar className="mb-8 reveal"
            left={<><FilterSelect label="Territorio" options={['Tutti', 'Nazionale', 'Locale']} /><FilterSelect label="Tipo" options={['Tutti', 'Webinar', 'Assemblea', 'Formazione']} /></>}
            right={<button className="btn btn--outline btn--sm">📅 Vedi Calendario</button>}
          />

          <div className="grid grid-3 gap-8">
            {data.events.map((e, i) => (
              <EventCard 
                key={e.id} 
                {...e}
                className={`reveal stagger-${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* DOCUMENTS SECTION - MATCHING DOCUMENTI PAGE STYLE */}
      <section className="section bg-subtle">
        <div className="container">
          <SectionHeader overline="Trasparenza" title="Documenti e Risorse" className="mb-8" />
          
          <Toolbar className="mb-8 reveal"
            left={<SearchBar placeholder="Cerca documento..." ariaLabel="Cerca" />}
            right={<FilterSelect label="Tipo" options={['Tutti', 'Guida', 'Report', 'Modulistica', 'Dossier']} />}
          />

          <div className="flex flex-col gap-4 reveal">
            {data.documents.map((d, i) => (
              <a 
                href="#" 
                className={`card flex justify-between items-center hover:border-primary transition-all stagger-${i + 1}`} 
                style={{ padding: 'var(--space-6)', background: '#fff', border: '1px solid var(--color-border-subtle)', borderRadius: 'var(--radius-xl)' }} 
                key={d.title}
              >
                <div style={{ flex: 1 }}>
                  <span className="badge badge--subtle mb-2" style={{ color: data.color, background: `${data.color}10` }}>{d.type}</span>
                  <h4 className="h5 mb-1">{d.title}</h4>
                  <span className="text-xs text-secondary uppercase tracking-wider">{d.date} • {d.size}</span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="badge badge--primary" style={{ background: data.color }}>{d.badge}</span>
                  <div className="btn btn--icon btn--sm btn--outline"><Icon name="Download" size={16} /></div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

    </Layout>
  );
};

export default DipartimentoPage;
